export default __webpack_public_path__ + "static/media/designer.71b9dee0.png";